import axiosApiInstance from "../../app/axios";
import { API_BASE_URL } from "../../app/utils";

const rolesUrl = `${API_BASE_URL}/user-store/v1/staff-roles`;
const permissionsUrl = `${API_BASE_URL}/user-store/v1/permissions`;

/** The catalogue with an inverse lookup of which roles hold each key. `ADM` is excluded server-side. */
export const getPermissionCatalogue = () => axiosApiInstance.get(permissionsUrl);

export const createRole = (request) => axiosApiInstance.post(rolesUrl, request);

/**
 * What a composition change would do, asked before it is made.
 *
 * A POST for a read because the proposed composition is a list, and a 90-key query string is a
 * truncation waiting to happen at some proxy. It writes nothing and records nothing.
 */
export const previewRolePermissions = (code, permissions) =>
  axiosApiInstance.post(`${rolesUrl}/${encodeURIComponent(code)}/preview`, { permissions });

/**
 * A whole-composition replacement rather than a delta, matching the API: two administrators editing
 * one role collide visibly instead of silently interleaving.
 */
export const setRolePermissions = (code, permissions, terminateSessions) =>
  axiosApiInstance.put(`${rolesUrl}/${encodeURIComponent(code)}/permissions`, {
    permissions,
    terminateSessions,
  });

export const deleteRole = (code) =>
  axiosApiInstance.delete(`${rolesUrl}/${encodeURIComponent(code)}`);
